import { Injectable } from '@angular/core';
import { ApiClientService } from './util/api.client.service';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

  constructor(public http: ApiClientService) { }

  getBySectionalTypeAndOfficeId(sectionalTypeId: any, officeId: any) {
    return this.http.get(`/appointment/calendar/sectionalType/${sectionalTypeId}/office/${officeId}/config`);
  }

  getAppointmentFilter(officeId: any, model: any) {
    return this.http.get(`/secure/appointment/office/${officeId}/filter?docNumber=${model.docNumber}&sex=${model.sex}&sectionalTypeId=${model.procedureTypeId}&dateFrom=${model.dateFrom}&dateTo=${model.dateTo}&size=10`);
  }

  getAppointmentById(appointmentId: any) {
    return this.http.get('/secure/appointment/' + appointmentId);
  }

  attendAppointment(appointment: any) {
    return this.http.put('/secure/appointment/' + appointment.id + '/attend', appointment);
  }

  absentAppointment(appointment: any) {
    return this.http.put('/secure/appointment/' + appointment.id + '/absent', appointment);
  }

  cancelAppointment(appointment: any) {
    return this.http.put('/secure/appointment/' + appointment.id + '/cancel?reassign=' +appointment.reassign , appointment);
  }

  cancelPublicAppointment(appointment: any) {
    return this.http.put('/appointment/' + appointment.id + '/cancel', appointment);
  }

  getByApplicantId(applicantId: any) {
    return this.http.get('/appointment/applicant/' + applicantId);
  }

  validateAppointment(model: any) {
    return this.http.put(`/appointment/${model.appointmentId}/validate`, model.data);
  }

  validateCertificate(model: any) {
    return this.http.put(`/appointment/certificate/${model.appointmentId}/validate`, model.data);
  }

  createAppointmentForOperator(model: any) {
    return this.http.post(`/secure/appointment/create`, model);
  }

  goToPage(link: any) {
    return this.http.getWithoutUri(link);
  }

  getCertificateByApplicant(applicantId: any){
    return this.http.get(`/appointment/applicant/${applicantId}/certificaterequest`);
  }

  consultationTicket(model: any) {
    return this.http.post(`/appointment/certificate/rent/ticket/validate`, model);
  }

  getShiftMaxCertificateRequest(request: string){
    return this.http.get(`/appointment/maxCertificateRequest/${request}`);
  }

  validateLicense(docNumber:string, license:string){
    return this.http.get(`/public/certificateRequest/validate/doc/${docNumber}/license?license=${license}`);
  }


  getAssociatedCertificatesByDocNumberAndCertificateTypeId(docNumber:string, certificateTypeId:number){
    return this.http.get(`/public/certificateRequest/certificatesAssociated/type/${certificateTypeId}/doc/${docNumber}`);
  }
}
